<div class="registration-container">
  <div class="form-view">
    <form [formGroup]="employeeForm" (ngSubmit)="submitEmployeeForm()" class="form-container">

      <h3 class="section-title">Employee Registration</h3>

      <div class="form-section">
        <mat-form-field appearance="outline">
          <mat-label>Employee No</mat-label>
          <input matInput formControlName="employee_no" required>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Registered Email</mat-label>
          <input matInput formControlName="registered_email" required>
        </mat-form-field>
      </div>

      <div class="form-actions">
        <button mat-raised-button class="submit-btn" type="submit">
          Submit Employee
        </button>
      </div>

    </form>
  </div>
</div>
